<script lang="ts" setup>
    import { CheckIcon } from '@lucide/vue';

    const model = defineModel<boolean>();

    defineProps<{
        startLabel?: string;
        label?: string;
        disabled?: boolean;
    }>();
</script>

<template>
    <label class="Toggle-switch" v-bind="$attrs">
        <span
            v-if="startLabel || $slots.startLabel"
            class="Toggle-switch__label text-body transition-colors group-hover:text-primary-beet"
        >
            <slot name="startLabel">{{ startLabel }}</slot>
        </span>
        <span class="Toggle-switch__box">
            <input v-model="model" type="checkbox" :disabled="disabled" />
            <span class="Toggle-switch__handle">
                <span
                    class="block p-0.5 transition-all duration-200 ease-in-out"
                    :class="{
                        'rotate-0 opacity-100': model,
                        '-rotate-45 opacity-0': !model,
                    }"
                >
                    <CheckIcon class="size-4" />
                </span>
            </span>
        </span>
        <span
            v-if="label || $slots.label"
            class="Toggle-switch__label text-body transition-colors group-hover:text-primary-beet"
        >
            <slot name="label">{{ label }}</slot>
        </span>
    </label>
</template>
